async function getCampanha() {
	const requestOptions = {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	};

	return fetch(process.env.REACT_APP_LABS_API + "OEC/campanha/get_campanha.php", requestOptions)
		.then(response => {
			return response.json();
		})
		.then(json => {
			return json;
		});
}

export { getCampanha };
